import { render, staticRenderFns } from "./ViewTask.vue?vue&type=template&id=162a4108&scoped=true"
import script from "./ViewTask.vue?vue&type=script&lang=js"
export * from "./ViewTask.vue?vue&type=script&lang=js"
import style0 from "./ViewTask.vue?vue&type=style&index=0&id=162a4108&prod&scoped=true&lang=css"
import style1 from "./ViewTask.vue?vue&type=style&index=1&id=162a4108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a4108",
  null
  
)

export default component.exports